<template>
  <div class="product__tabs product-tabs product-tabs--layout--sidebar" v-if="tabs.length > 0">
    <ul class="product-tabs__list">
      <li v-for="(tab, index) in tabs" :key="tab.name" class="product-tabs__item" :class="activeTabIndex === index ? 'product-tabs__item--active' : ''">
        <a href="javascript:void(0);" @click="ShowTab(index)">
            {{ tab.name }}          
        </a>
      </li>
      <li class="product-tabs__item" :class="activeTabIndex === index ? 'product-tabs__item--active' : ''">
        <a href="javascript:void(0);" @click="ShowTab(index)">
           Specifications          
        </a>
      </li>
    </ul>
    <div class="product-tabs__content">
      <div v-for="(tab, index) in tabs" :key="tab.name" class="product-tabs__pane" :class="activeTabIndex === index ? 'product-tabs__pane--active' : ''">
        <!-- <div class="typography">{{prod_desc}}</div> -->
        <div class="typography" v-html="tab.content"></div>
      </div>
      <div class="product-tabs__pane" :class="activeTabIndex === index ? 'product-tabs__pane--active' : ''">
        <!-- <div class="typography">{{prod_desc}}</div> -->
        <div class="typography">
            <table class="table specs">
              <tr v-for="(attr, index) in attributes" :key="index">
                <th style="">{{attr.name}}</th>
                <td>{{attr.value}}</td>
              </tr>
            </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        tabs: {
          type: Array,
          required: true
        },
        attributes: {
          type: Array,
          required: true
        },
        prod_desc: {
          type: String,
        }
    },
    data() {
        return {
            max_stars : 5,
            activeTabIndex: 0,
        }
    },
    methods: {
      ShowTab(index){
          this.activeTabIndex = index;
      }
    },
    created() {
      this.activeTabIndex = 0;
    }
}
</script>

<style scoped>
  .table.specs tr th, .table.specs tr td {
    border: 1px solid #dee2e6  !important;
  }
</style>